<template>
  <div class="main">
    <div class="main_right">
      <div class="page_info">
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem>修改配置</BreadcrumbItem>
        </Breadcrumb>
        <div class="dev_data">
          <div><b style="display: inline-block; color: red; width: 10px;">*</b><span style="display: inline-block;width: 70px;text-align: left;">配置名</span><Input v-model="configForm.configName" style="width: 300px" :maxlength=32 /></div>
          <div><b style="display: inline-block; color: red; width: 10px;"></b><span style="display: inline-block;width: 70px;text-align: left;">注册url</span><Input v-model="configForm.registerUrl" style="width: 300px" :maxlength=32 /></div>
          <div><b style="display: inline-block; color: red; width: 10px;"></b><span style="display: inline-block;width: 70px;text-align: left;">开门记录url</span><Input v-model="configForm.openDoorRecordUrl" style="width: 300px" :maxlength=32 /></div>
          <div><b style="display: inline-block; color: red; width: 10px;"></b><span style="display: inline-block;width: 70px;text-align: left;">报警记录url</span><Input v-model="configForm.alarmRecordUrl" style="width: 300px" :maxlength=32 /></div>
          <div><b style="display: inline-block; color: red; width: 10px;"></b><span style="display: inline-block;width: 70px;text-align: left;">心跳url</span><Input v-model="configForm.heartBeatUrl" style="width: 300px" :maxlength=32 /></div>
          <div><b style="display: inline-block; color: red; width: 10px;"></b><span style="display: inline-block;width: 70px;text-align: left;">密钥</span><Input v-model="configForm.secretKey" style="width: 300px" :maxlength=32 /></div>
          <div class="btn">
            <Button type="primary" style="width: 120px;" @click="submit">确定</Button>
            <Button style="width: 120px;" @click="goBackPage">取消</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {httpUrl} from '../../api/index'
import TopOpe from '../top-ope/top-ope'
import {nError, nSuccess} from '../../util/notice'
import {errorHandler} from '../../util/errorHandler'

export default {
  components: {TopOpe},
  name: 'modify-config',
  data () {
    return {
      configForm: {
        configName: '',
        registerUrl: '',
        openDoorRecordUrl: '',
        alarmRecordUrl: '',
        heartBeatUrl: '',
        secretKey: ''
      }
    }
  },
  created () {
    let searchId = this.$route.params.id
    this.getConfig(searchId)
  },
  methods: {
    goBackPage () {
      this.$router.push({
        path: '/config_management'
      })
    },
    getConfig (id) {
      this.$axios.get(`${httpUrl.url}/manage/config/getById/${id}`)
        .then(res => {
          if (res.data.retCode === 1) {
            this.configForm = res.data.data
          }
        })
        .catch(errorHandler('查询失败'))
    },
    submit () {
      if (!this.configForm.configName) {
        nError('配置名不能为空')
        return false
      }
      this.configForm.id = parseInt(this.$route.params.id)
      this.$axios.post(`${httpUrl.url}/manage/config/update`, this.configForm)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('修改成功')
            this.$router.push({
              path: '/config_management'
            })
          }
        })
        .catch(errorHandler('修改失败'))
    }
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .main_right {
    width: 100%;
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }
  .page_info {
    margin: 15px;
    background-color: #fff;
  }

  .dev_data {
    margin-top: 80px;
  }

  .dev_data div {
    margin: 10px;
    text-align: center;
  }

  .btn button {
    margin: 30px 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/config-management/modify-config.vue